const getters = {
    token: state => state.common.token,
    appUserType: state => state.common.appUserType,
    // roleCode: state => state.common.roleCode,
    // nickName: state => state.common.nickName,
    // id: state => state.common.id,
    // confirmStatus: state => state.common.confirmStatus,
    // addressList: state => state.common.addressList,
    // originaltoken: state => state.common.originaltoken,
  }
export default getters